// extracted by mini-css-extract-plugin
export default {"div_imagem_usuario":"ImagemUsuario_div_imagem_usuario__+qN1g","imagem_usuario":"ImagemUsuario_imagem_usuario__1OA3t"};